export interface SurveyRoles<T = string> {
  viewer: T[];
  admin: T[];
}

export enum SurveyType {
  Default = 'default',
  Aggregation = 'aggregation',
  Materiality = 'materiality',
  AutoAggregation = 'auto_aggregation',
}

export enum ScopeGroups {
  Sdg = 'sdg',
  /** @deprecated */
  Materiality = 'materiality',
  Standards = 'standards',
  Frameworks = 'frameworks',
  Custom = 'custom'
}

export interface SurveyScope {
  [ScopeGroups.Sdg]: string[],
  /** @deprecated */
  [ScopeGroups.Materiality]: string[],
  [ScopeGroups.Standards]: string[],
  [ScopeGroups.Frameworks]: string[],
  [ScopeGroups.Custom]: string[],
}
